import { atom, selectorFamily } from 'recoil'

export const activeAudioPlayerAtom = atom<string | null>({
  key: "activeAudioPlayerAtom",
  default: null,
});

export const isAudioPlayingSelector = selectorFamily<boolean, string>({
  key: "isAudioPlayingSelector",
  get: (audioInstanceKey) => ({ get }) => {
    const activeKey = get(activeAudioPlayerAtom);
    return activeKey === audioInstanceKey;
  },
});